module.exports = __webpack_public_path__ + "9d81624f.png";